import CheckIcon from '@mui/icons-material/Check'
import ClearIcon from '@mui/icons-material/Clear'
import {Box, TableCell, Typography, useTheme} from '@mui/material'
import {alpha} from '@mui/material/styles'
import {useTranslation} from 'react-i18next'

export const BooleanValueCell = ({value}: {value: string | undefined}) => {
  const {t} = useTranslation()
  const theme = useTheme()

  if (value === undefined) return <TableCell />

  return (
    <TableCell>
      {value === 'Yes' ? (
        <Box
          alignItems="center"
          display="flex"
          gap="5px"
          width="fit-content"
          sx={{
            borderRadius: '15px',
            border: `1px solid ${theme.palette.success.light}`,
            padding: '5px',
            background: alpha(theme.palette.success.light, 0.05)
          }}
        >
          <CheckIcon color="success" />
          <Typography variant="caption" marginRight={1}>
            {t('materialsSettings.yes')}
          </Typography>
        </Box>
      ) : (
        <Box
          alignItems="center"
          display="flex"
          gap="5px"
          width="fit-content"
          sx={{
            borderRadius: '15px',
            border: `1px solid ${theme.palette.grey[200]}`,
            padding: '5px',
            background: theme.palette.grey[100]
          }}
        >
          <ClearIcon htmlColor={theme.palette.grey[600]} />
          <Typography variant="caption" marginRight={1}>
            {t('materialsSettings.no')}
          </Typography>
        </Box>
      )}
    </TableCell>
  )
}
